import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { AttributeTypeWriteRequest } from '@/api/handlers/resources/attributeTypes/requests';
import type { ApiResponse } from '@/api/handlers/responses';
import type { AttributeType } from '@/api/models';
import { AttributeQueryKeys } from './attributeQueryKeys';

export type UpdateAttributeTypeVariables = {
    id: string;
    body: AttributeTypeWriteRequest;
};

export const useUpdateAttributeTypeMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<AttributeType>,
        Error,
        UpdateAttributeTypeVariables
    >({
        mutationFn: ({ id, body }) =>
            apiClient.attributeTypes.updateAttributeType(id, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: AttributeQueryKeys.all,
                });
            }
        },
    });
};
